module.exports = __webpack_public_path__ + "img/logo.c3ec17a6.png";